import api from "./axiosInstance";

export const getPayees = async () => {
  const res = await api.get("api/v1/payees/");
  return res.data;
};

export const getAllPayees = async () => {
  const res = await api.get("api/v1/payees/?limit===999");
  return res.data;
};

export const createPayee = async (payload) => {
  const res = await api.post(`api/v1/payees/`, payload);
  return res.data;
};

export const updatePayee = async (id, payload) => {
  const res = await api.patch(`api/v1/payees/${id}/`, payload);
  return res.data;
};

export const deletePayee = async (id) => {
  await api.delete(`api/v1/payees/${id}/`);
};
